var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudittrailsSideicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 18.9582H6.66667C3.625 18.9582 1.875 17.2082 1.875 14.1665V5.83317C1.875 2.7915 3.625 1.0415 6.66667 1.0415H13.3333C16.375 1.0415 18.125 2.7915 18.125 5.83317V14.1665C18.125 17.2082 16.375 18.9582 13.3333 18.9582ZM6.66667 2.2915C4.28333 2.2915 3.125 3.44984 3.125 5.83317V14.1665C3.125 16.5498 4.28333 17.7082 6.66667 17.7082H13.3333C15.7167 17.7082 16.875 16.5498 16.875 14.1665V5.83317C16.875 3.44984 15.7167 2.2915 13.3333 2.2915H6.66667Z",
    fill: "#909AB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 7.70833H13.75C12.4833 7.70833 11.4583 6.68333 11.4583 5.41667V3.75C11.4583 3.40833 11.7416 3.125 12.0833 3.125C12.425 3.125 12.7083 3.40833 12.7083 3.75V5.41667C12.7083 5.99167 13.175 6.45833 13.75 6.45833H15.4166C15.7583 6.45833 16.0416 6.74167 16.0416 7.08333C16.0416 7.425 15.7583 7.70833 15.4166 7.70833Z",
    fill: "#909AB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.4585H6.66669C6.32502 11.4585 6.04169 11.1752 6.04169 10.8335C6.04169 10.4918 6.32502 10.2085 6.66669 10.2085H10C10.3417 10.2085 10.625 10.4918 10.625 10.8335C10.625 11.1752 10.3417 11.4585 10 11.4585Z",
    fill: "#909AB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 14.7915H6.66669C6.32502 14.7915 6.04169 14.5082 6.04169 14.1665C6.04169 13.8248 6.32502 13.5415 6.66669 13.5415H13.3334C13.675 13.5415 13.9584 13.8248 13.9584 14.1665C13.9584 14.5082 13.675 14.7915 13.3334 14.7915Z",
    fill: "#909AB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudittrailsSideicon);
export default __webpack_public_path__ + "static/media/Audit trails - side icon.a16f54824b3fd35f4eba8570a390478d.svg";
export { ForwardRef as ReactComponent };